import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { createPortal } from "react-dom";

const SessionExpiredModal = ({ onLogout, countdown = 3 }) => {
  const [timeLeft, setTimeLeft] = useState(countdown);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        const newTime = prev - 1;
        if (newTime <= 0) {
          clearInterval(interval);
          onLogout();
          return 0;
        }
        return newTime;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [onLogout]);

  return createPortal(
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 9999,
      }}
    >
      <Box
        sx={{
          maxWidth: 480,
          width: "90%",
          backgroundColor: "#fff",
          borderRadius: "14px",
          padding: 3,
          boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
        }}
      >
        {/* SVG Illustration */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mb: 2,
          }}
        >
          <img
            src="/timeout.svg"
            alt="Session Expired"
            style={{
              width: "180px",
              height: "auto",
              maxWidth: "100%",
            }}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: 2,
            mb: 2,
          }}
        >
          <InfoOutlinedIcon
            sx={{
              fontSize: 24,
              color: "#5f6368",
              mt: 0.5,
            }}
          />
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 500,
                color: "#202124",
                mb: 1,
                fontSize: "18px",
              }}
            >
              Session Expired
            </Typography>

            <Typography
              variant="body2"
              sx={{
                color: "#5f6368",
                mb: 2,
                lineHeight: 1.5,
                fontSize: "14px",
              }}
            >
              Your session has expired! You'll be redirected to the login page in {timeLeft} second
              {timeLeft !== 1 ? "s" : ""}.
            </Typography>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                pt: 1,
              }}
            >
              <Box
                sx={{
                  width: 16,
                  height: 16,
                  border: "2px solid #e8eaed",
                  borderTopColor: "#1a73e8",
                  borderRadius: "50%",
                  animation: "spin 0.8s linear infinite",
                  "@keyframes spin": {
                    "0%": { transform: "rotate(0deg)" },
                    "100%": { transform: "rotate(360deg)" },
                  },
                }}
              />
              <Typography
                variant="caption"
                sx={{
                  color: "#80868b",
                  fontSize: "13px",
                }}
              >
                Redirecting...
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>,
    document.body,
  );
};

export default SessionExpiredModal;
